module.exports = __webpack_public_path__ + "static/the-master-algorithm-a54c5f7274f9c5b29172ed29d6487a45.jpg";